import { Box, CircularProgress, IconButton, Typography } from '@mui/material'
import UploadFile from './UploadFile'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { Close } from '@mui/icons-material'
import { removeDrawingFile } from '../../actions/files'
import { FileType } from '../../models/File'

interface UploadFilesProps {
  cleanupFunctionsRef?: React.MutableRefObject<(() => void)[]>
}

const UploadFiles: React.FC<UploadFilesProps> = ({ cleanupFunctionsRef }) => {
  const dispatch = useDispatch<any>()
  const drawings = useSelector((state: RootState) => state.drawings)
  const files = drawings.files

  const onRemoveUploadedFileClick = (fileId: string) => {
    dispatch(removeDrawingFile({ fileId }))
  }

  return (
    <Box
      sx={{
        height: '100%',
      }}
    >
      <>
        <Box sx={{ height: '80%' }}>
          <UploadFile cleanupFunctionsRef={cleanupFunctionsRef} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: '12px',
          }}
        >
          {drawings.filesType === FileType.Pdf ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
              }}
            >
              <Typography
                sx={{
                  color: '#04002E',

                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                Uploaded
              </Typography>

              <Box
                sx={{
                  height: '190px',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '16px',
                }}
              >
                {files.map((file, index) => (
                  <Box
                    key={file.id}
                    sx={{
                      boxSizing: 'border-box',
                      flex: '0 0 160px',
                      display: 'flex',
                      flexDirection: 'column',
                      maxWidth: '160px',
                      gap: '14px',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <IconButton
                        onClick={() => onRemoveUploadedFileClick(file.id)}
                        sx={{
                          ml: 'auto',
                          backgroundColor: '#F5F5F5',
                          width: '12px',
                          height: '12px',
                          boxShadow:
                            '0px 3.534px 5.891px 0px rgba(0, 0, 0, 0.25)',
                        }}
                      >
                        <Close
                          sx={{
                            width: '12px',
                            height: '12px',
                          }}
                        />
                      </IconButton>

                      <Box
                        sx={{
                          position: 'relative',
                          display: 'inline-block',
                        }}
                      >
                        {!!!file.s3Filename && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '150px',
                              height: '110px',
                              borderRadius: '2.356px',
                              border: '1px solid rgba(0, 0, 0, 0)',
                              backgroundColor: 'rgba(0, 0, 0, 0.5)',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <CircularProgress
                              sx={{
                                color: '#EEEEEE',
                              }}
                            />
                          </Box>
                        )}

                        <img
                          src={file.pages[0].image}
                          alt={`Page 0 of file ${index + 1}`}
                          style={{
                            width: '150px',
                            height: '110px',
                            objectFit: 'fill',
                            borderRadius: '2.356px',
                            border: '1px solid #B6B6B6',
                            boxShadow:
                              '0px 3.534px 5.891px 0px rgba(0, 0, 0, 0.25)',
                          }}
                        />
                      </Box>
                    </Box>

                    <Typography
                      sx={{
                        color: '#04002E',

                        fontSize: '12px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                      }}
                    >
                      {file.name}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                mt: '10px',
              }}
            >
              {drawings.files.map((file, index) => (
                <Box key={index} sx={{ display: 'flex', gap: '10px' }}>
                  <Typography
                    sx={{
                      color: '#04002E',
                      fontSize: '12px',
                      lineHeight: 'normal',
                    }}
                  >
                    {`${file.name} ${file.s3Filename ? 'uploaded' : 'is uploading'}`}
                  </Typography>
                  {!!!file.s3Filename && <CircularProgress size={'12px'} />}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </>
    </Box>
  )
}

export default UploadFiles
